import { Drawer } from '@cad-arc';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { ServiceRotationDrawerContent } from './service-rotation-drawer-content';
import { TowRotationProps } from './types';

export function ServiceRotationDrawer({
    eventId,
    defaultServiceRotationTypeId,
    towRotationProps,
}: {
    eventId: number;
    defaultServiceRotationTypeId?: number;
    towRotationProps?: TowRotationProps;
}): React.ReactElement {
    const drawerControls = useDrawerControls();

    return (
        <Drawer isOpen size="lg" onClose={() => drawerControls.close()}>
            <ServiceRotationDrawerContent
                eventId={eventId}
                towRotationProps={towRotationProps}
                defaultServiceRotationTypeId={defaultServiceRotationTypeId}
            />
        </Drawer>
    );
}

type ServiceRotationDrawerType = typeof ServiceRotationDrawer;

export type { ServiceRotationDrawerType };
